function isEqual(objA, objB) {
  // Not really perf friendly but easy to implement
  return JSON.stringify(objA) === JSON.stringify(objB)
}

function deepClone(obj) {
  // Not really perf friendly but easy to implement
  return JSON.parse(JSON.stringify(obj))
}

export { deepClone, isEqual }
